//@flow
import React, { Component } from "react";
import { Dimensions } from "react-native";
import { Box, ImageSliders, MySafeAreaView } from "../../components/common";
import { connect } from "react-redux";
import {
  changeSignupProgress,
  changeSignupStats,
  signupOnboardingEndRequest,
} from "@microdoing/shared/services/signup/actions";
import i18n from "@microdoing/shared/i18n";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import { changeNavField } from "@microdoing/shared/services/nav/actions";
import {
  getHasCustomOnboarding,
  getDefaultUserSkills,
} from "@microdoing/shared/services/client/selectors";
import { getIsConnected } from "@microdoing/shared/services/network/selectors";
import theme from "app/Theme/Theme";
import { SafeAreaView } from "react-native-safe-area-context";

const ConfidenceImage = require("../../../assets/images/confidence.png");
const TeamImage = require("../../../assets/images/teamCohesion.png");
const SpeakingImage = require("../../../assets/images/team.png");
const StressImage = require("../../../assets/images/stress.png");

const { width, height } = Dimensions.get("window");
const aspectRatio = height / width;
const isPad = () => aspectRatio < 1.6;

class Signup extends Component {
  componentDidMount() {
    this.props.changeNavField({
      safeAreaViewBackgroundColor: theme.colors["neutral.white"],
    });
  }

  submitEnd = async () => {
    this.props.changeSignupProgress(this.props.progressRatio);
    this.props.signupOnboardingEndRequest();
  };

  goNext = () => {
    const { hasCustomOnboarding = false } = this.props;
    if (hasCustomOnboarding) return this.submitEnd();
    this.props.navigation.navigate("SignupTopics");
  };

  goBack = () => {
    this.props.changeSignupProgress(-this.props.progressRatio);
    this.props.navigation.goBack();
  };

  onValueChange = name => value => {
    this.props.changeSignupStats({ [name]: value });
  };

  generateSlides = () => {
    const {} = this.props;
    const normalSlides = [
      {
        value: this.props.confidence,
        firstTitle: i18n.t("signup2-title-first"),
        secondTitle: i18n.t("signup2-title-second"),
        onValueChange: this.onValueChange("confidence"),
        image: ConfidenceImage,
        leftLabel: i18n.t("low"),
        rightLabel: i18n.t("high"),
      },
      {
        value: this.props.stress,
        firstTitle: i18n.t("signup3-title-first"),
        secondTitle: i18n.t("signup3-title-second"),
        onValueChange: this.onValueChange("stress"),
        image: StressImage,
        leftLabel: i18n.t("hardly"),
        rightLabel: i18n.t("easily"),
      },
      {
        value: this.props.publicSpeaking,
        firstTitle: i18n.t("signup4-title-first"),
        secondTitle: i18n.t("signup4-title-second"),
        onValueChange: this.onValueChange("publicSpeaking"),
        image: SpeakingImage,
        leftLabel: i18n.t("weakly"),
        rightLabel: i18n.t("highly"),
      },
      {
        value: this.props.teamCohesion,
        firstTitle: i18n.t("signup5-title-first"),
        secondTitle: i18n.t("signup5-title-second"),
        onValueChange: this.onValueChange("teamCohesion"),
        image: TeamImage,
        leftLabel: i18n.t("low"),
        rightLabel: i18n.t("high-e"),
      },
    ];

    return normalSlides;
  };

  render() {
    return (
      <MySafeAreaView flex={1}>
        <Box variant="screenView" flex={1} backgroundColor={"neutral.white"}>
          <ImageSliders
            progress={this.props.progress}
            headerTitle={i18n.t("signup-header")}
            isConnected={this.props.isConnected}
            progressRatio={this.props.progressRatio}
            goBack={this.goBack}
            goNext={this.goNext}
            changeProgress={this.props.changeSignupProgress}
            slides={this.generateSlides()}
            requesting={this.props.requesting}
          />
        </Box>
      </MySafeAreaView>
    );
  }
}

const mapStateToProps = state => {
  const { language } = state.profileSettings;
  const {
    stats,
    progress,
    progressRatio,
    userTopicChoices,
    topicOptions,
    choice,
    choiceAvailable,
    firstName,
    lastName,
    birthDate,
    sex,
    manager,
    requesting,
    jobFunction,
    mbti,
  } = state.signup;
  const { appAccess } = state.user;
  const hasCustomOnboarding = getHasCustomOnboarding(state);
  const defaultUserSkills = getDefaultUserSkills(state);

  const {
    confidence,
    stress,
    publicSpeaking,
    teamCohesion,
    position,
    recruiting,
    integration,
    training,
    preparation,
    briefing,
    visualization,
    debriefing,
    capitalization,
    motivation,
    leadership,
  } = stats;

  return {
    userId: getUserId(state),
    picture: state.user.picture,
    language,
    defaultUserSkills,
    hasCustomOnboarding,
    isConnected: getIsConnected(state),
    appAccess,
    confidence,
    stress,
    publicSpeaking,
    teamCohesion,
    position,
    recruiting,
    integration,
    training,
    preparation,
    briefing,
    visualization,
    debriefing,
    capitalization,
    motivation,
    leadership,
    progress,
    progressRatio,
    stats,
    userTopicChoices,
    topicOptions,
    choice,
    choiceAvailable,
    firstName,
    lastName,
    birthDate,
    sex,
    manager,
    requesting,
    jobFunction,
    mbti,
  };
};

export default connect(mapStateToProps, {
  changeSignupProgress,
  signupOnboardingEndRequest,
  changeSignupStats,
  changeNavField,
})(Signup);
